<template>

</template>

<script>

export default {
  title: "New",
  access_code: "UBW_FORM01",
  created() {
      this.$router.push("/Builder/Workflow/Request")
  }
};
</script>

<style>
</style>